<template>
  <b-container>
    <b-row class="justify-content-end">
      <b-button variant="info" class="mt-3 mx-3" @click="goToCreateDocument">افزودن مستند جدید</b-button>
    </b-row>
    <b-row class="mt-4">
      <b-card class="w-100 shadow text-right m-3">
        <b-container>
          <b-row class="justify-content-end align-items-center">
            <b-col md="2">
              <b-button pill variant="outline-info" size="sm" @click="searchDocuments" class="w-100">
                <b-icon icon="search" class="m-1"></b-icon> جستجو
              </b-button>
              <b-button v-if="searchTerm.length > 0" pill size="sm" variant="outline-secondary" @click="clearSearch"
                class="w-100 mt-1">
                <b-icon icon="x" class="m-1"></b-icon>پاک کردن
              </b-button>
            </b-col>
            <b-col md="6">
              <label for="input_searchBy" class="text-right w-100 mt-3">جستجو</label>
              <b-form-input type="search" class="w-100 rtl" v-model="searchTerm"
                :placeholder="(selectSearchBy.selected.length > 0) ? selectSearchBy.selected.map((o) => o.value).join(' , ') + ' ... ' : 'جستجو در عنوان، متن و کد مرجع'">
              </b-form-input>
            </b-col>
            <b-col md="4">
              <label for="input_searchBy" class="text-right w-100 mt-3">جستجو بر اساس</label>
              <multiselect id="input_searchBy" v-model="selectSearchBy.selected" :options="selectSearchBy.options"
                :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true"
                selectLabel="فشردن Enter برای انتخاب" selectedLabel="انتخاب شده"
                deselectLabel="فشردن Enter برای رد انتخاب" noOptions="موردی یافت نشد"
                :placeholder="selectSearchBy.first" label="value" track-by="value" @input="onSearchByChanged">
              </multiselect>
            </b-col>
          </b-row>
        </b-container>
      </b-card>
      <b-card class="w-100 shadow text-right m-3">
        <b-container>
          <b-row class="justify-content-end align-items-center">
            <b-col md="6" class="my-2">
              <label for="input_topics" class="text-right w-100">سرفصل ها</label>
              <multiselect id="input_topics" v-model="selectTopics.selected" :options="selectTopics.options"
                :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true"
                select-label="فشردن Enter برای انتخاب" selected-label="انتخاب شده"
                deselect-label="فشردن Enter برای رد انتخاب" no-options="موردی یافت نشد"
                :custom-label="({ title }) => title" :placeholder="selectTopics.first" label="title" track-by="title"
                @input="onTopicFilterChanged"></multiselect>
            </b-col>
            <b-col md="6" class="my-2">
              <label for="input_keywords" class="text-right w-100">کلیدواژه ها</label>
              <multiselect id="input_keywords" v-model="selectKeywords.selected" :options="selectKeywords.options"
                :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true"
                select-label="فشردن Enter برای انتخاب" selected-label="انتخاب شده"
                deselect-label="فشردن Enter برای رد انتخاب" no-options="موردی یافت نشد" :custom-label="
                  ({ name, is_deprecated, alice_keyword }) =>
                    name +
                    (alice_keyword && is_deprecated
                      ? '(ر.ج: ' + alice_keyword.name + ')'
                      : '')
                " :placeholder="selectKeywords.first" label="name" track-by="name" @input="onKeywordFilterChanged">
              </multiselect>
            </b-col>
            <b-col md="6" class="my-2">
              <label for="input_references" class="text-right w-100">منابع</label>
              <multiselect id="input_references" v-model="selectReferences.selected" :options="selectReferences.options"
                :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true"
                select-label="فشردن Enter برای انتخاب" selected-label="انتخاب شده"
                deselect-label="فشردن Enter برای رد انتخاب" no-options="موردی یافت نشد" :custom-label="
                  ({ content_title, formated_jalali_held_at }) =>
                    content_title + ' (' + formated_jalali_held_at + ') '
                " :placeholder="selectReferences.first" label="content_title" track-by="content_title"
                @input="onReferenceFilterChanged"></multiselect>
            </b-col>
          </b-row>
        </b-container>
      </b-card>
    </b-row>
    <b-row>
      <p v-show="nothingToShow" class="text-center text-secondary rtl w-100">هیچ مستندی یافت نشد <b-button pill
          variant="outline-secondary" size="sm" @click="goToCreateDocument">افزودن جدید</b-button>
      </p>
      <b-card v-show="!nothingToShow" class="w-100 shadow text-right m-3">
        <b-table striped hover :items="documentTable.items" :fields="documentTable.fields" no-local-sorting
          @sort-changed="onTableSortChanged" id="table_document" :busy="loading" caption-top
          :sort-by.sync="documentTable.sortBy" :sort-desc.sync="documentTable.sortDesc">
          <template #table-caption>لیست سند ها</template>
          <template #table-busy>
            <div class="text-center text-info my-2">
              در حال دریافت اطلاعات
              <b-spinner class="align-middle m-1" small></b-spinner>
            </div>
          </template>
          <template #cell(first_reference_content_title)="row">
            <a v-if="Array.isArray(documents[row.index].references) && documents[row.index].references.length > 0"
              :href="'/references/' + documents[row.index].references[0]._id + '/edit'" target="_blank"
              rel="noopener noreferrer">{{ row.value }}</a>
            <p v-else class="color-secondary">{{ row.value }}</p>
          </template>
          <template #cell(actions)="row">
            <b-button variant="outline-info" size="sm" class="m-1" @click="editDocumentRow(row)">
              <b-icon icon="pencil" class="m-1"></b-icon>ویرایش
            </b-button>
            <b-button variant="outline-info" size="sm" class="m-1"
              :href="'https://meshkat.resalatuniversity.ir/documents/' + documents[row.index]._id" target="_blank"
              rel="noopener noreferrer">
              <b-icon icon="box-arrow-up-right" class="m-1"></b-icon>مشاهده
            </b-button>
            <b-button variant="outline-danger" size="sm" class="m-1" @click="removeDocumentRow(row)">
              <b-icon icon="trash" class="m-1"></b-icon>حذف
            </b-button>
          </template>
        </b-table>
        <b-pagination v-show="pagination.count != 0" v-model="pagination.page" :total-rows="pagination.count"
          :per-page="pagination.limit" class="mt-3" align="center" aria-controls="table_document"
          @page-click="clickOnPage"></b-pagination>
      </b-card>
    </b-row>
  </b-container>
</template>
<script>
import _ from 'lodash'
import qs from 'querystring'

export default {
  name: 'DocumentsTable',
  data: () => ({
    loading: false,
    nothingToShow: false,
    selectSearchBy: {
      options: [
        { key: "title", value: "عنوان" },
        { key: "content", value: "متن" },
        { key: "code", value: "کد مرجع" }
      ],
      selected: [],
      first: 'پیش فرض'
    },
    selectKeywords: {
      options: [],
      selected: [],
      first: 'انتخاب یک یا چند کلیدواژه',
    },
    selectTopics: {
      items: [],
      options: [],
      selected: [],
      first: 'انتخاب یک یا چند سرفصل',
    },
    selectReferences: {
      options: [],
      selected: [],
      first: 'انتخاب یک یا چند منبع',
    },
    documents: [],
    documentTable: {
      fields: [
        {
          key: "code",
          label: "کد مرجع"
        },
        {
          key: "title",
          label: "عنوان"
        },
        {
          key: "created_at",
          label: "تاریخ ایجاد",
          sortable: true
        },
        {
          key: "updated_at",
          label: "تاریخ آخرین ویرایش",
          sortable: true
        },
        {
          key: "last_reference_held_at",
          label: "تاریخ جلسه",
          sortable: true
        },
        {
          key: "first_reference_content_title",
          label: "منبع",
          sortable: false
        },
        {
          key: "actions",
          label: "عملیات"
        }
      ].reverse(),
      items: [],
      sortBy: 'created_at',
      sortDesc: true
    },
    searchTerm: '',
    queryParams: {},
    pagination: {
      count: 0,
      page: 1,
      limit: 20
    }
  }),
  created() {
    this.loadLatestQueryParamsState()
  },
  mounted() {
    this.fetchDocumentsData()

    setTimeout(() => {
      this.fetchKeywordsData()

      this.fetchTopicsData()

      this.fetchReferencesData()
    }, 1000)
  },
  methods: {
    fetchKeywordsData() {
      this.loading = true
      this.$axios.get('/keywords', {
        params: qs.stringify({
          limit: -1,
          page: 1,
          select: 'without_date',
          filter: 'include_deprecated',
        })
      }).then((response) => {
        const body = response.data
        this.selectKeywords.options = body.data
        if (this.queryParams.keyword_ids) {
          this.selectKeywords.selected = _.map(
            this.queryParams.keyword_ids.split(','),
            (keywordId) =>
              _.find(
                this.selectKeywords.options,
                (elem) => elem._id === keywordId
              )
          )
        }
      }).catch((err) => {
        this.$bvToast.toast(err.text, { variant: 'danger', title: 'خطا' })
      }).finally(() => {
        this.loading = false
      })
    },
    fetchTopicsData() {
      this.loading = true
      this.$axios.get('/topics', {
        params: qs.stringify({ limit: -1, page: 1, select: 'tiny' })
      }).then((response) => {
        const body = response.data
        this.selectTopics.options = body.data
        if (this.queryParams.topic_ids) {
          this.selectTopics.selected = _.map(
            this.queryParams.topic_ids.split(','),
            (topicId) =>
              _.find(this.selectTopics.options, (elem) => elem._id === topicId)
          )
        }
      }).catch((err) => {
        this.$bvToast.toast(err.text, { variant: 'danger', title: 'خطا' })
      }).finally(() => {
        this.loading = false
      })
    },
    fetchReferencesData() {
      this.loading = true
      this.$axios.get('/references', {
        params: qs.stringify({ select: 'tiny_with_held_at', limit: -1, page: 1 })
      }).then((response) => {
        const body = response.data
        this.selectReferences.options = body.data
        if (this.queryParams.reference_ids) {
          this.selectReferences.selected = _.map(
            this.queryParams.reference_ids.split(','),
            (referenceId) =>
              _.find(
                this.selectReferences.options,
                (elem) => elem._id === referenceId
              )
          )
        }
      }).catch((err) => {
        this.$bvToast.toast(err.text, { variant: 'danger', title: 'خطا' })
      }).finally(() => {
        this.loading = false
      })
    },
    fetchDocumentsData() {
      this.loading = true

      this.$axios.get('/documents', {
        params: this.queryParams
      }).then((response) => {
        const body = response.data

        if (body.count == 0) {
          this.nothingToShow = true
        } else {
          this.documents = body.data
          this.documentTable.items = _.map(body.data, (o) => {
            return {
              code: o.code,
              title: o.title,
              created_at: o.formated_jalali_created_at,
              updated_at: o.formated_jalali_updated_at,
              last_reference_held_at: o.formated_jalali_last_reference_held_at,
              first_reference_content_title: (Array.isArray(o.references) && o.references.length > 0) ? o.references[0].content_title : 'ندارد'
            }
          })
          this.pagination.count = body.count
        }
      }).catch((err) => {
        this.$bvToast.toast(err.text, { variant: 'danger', title: 'خطا' })
      }).finally(() => {
        this.$store.commit('setFetchDataParamsState', { document: this.queryParams })
        this.loadLatestPagination()
        this.loading = false
      })
    },
    loadLatestPagination() {
      this.pagination.page = this.queryParams.page
      this.pagination.limit = this.queryParams.limit
    },
    loadLatestQueryParamsState() {
      this.queryParams = (this.$store.state.fetchDataParams) ? this.$store.state.fetchDataParams.document : null
      if (this.queryParams) {
        if (this.queryParams.q) {
          this.searchTerm = this.queryParams.q
        }
        if (this.queryParams.search_by) {
          this.selectSearchBy.selected = _.map(this.queryParams.search_by.split(','), (searchByKey) => {
            return {
              key: searchByKey,
              value: this.selectSearchBy.options.find(elem => elem.key == searchByKey).value
            }
          })
        }
        if (this.queryParams.sort_by) {
          this.documentTable.sortBy = this.queryParams.sort_by
          this.documentTable.sortDesc = (this.queryParams.sort_order == 'desc')
        }
        this.loadLatestPagination()
        this.queryParams.select = 'reference'
      } else {
        this.queryParams = {
          limit: this.pagination.limit,
          page: this.pagination.page,
          select: 'reference'
        }
      }
    },
    searchDocuments() {
      if (this.searchTerm && typeof this.searchTerm == 'string' && this.searchTerm.length > 0) {
        this.queryParams["q"] = this.searchTerm
      }
      this.fetchDocumentsData()
    },
    goToCreateDocument() {
      this.$router.push({ name: 'CreateDocument' })
    },
    editDocumentRow(row) {
      let document = this.documents[row.index]
      this.$router.push({ name: 'EditDocument', params: { document_id: document._id } })
    },
    removeDocumentRow(row) {
      this.$bvModal.msgBoxConfirm('آیا از حذف ' + row.item.title + ' اطمینان دارید؟', {
        title: 'توجه',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'بله',
        cancelTitle: 'بستن',
        bodyClass: 'text-right',
        headerClass: 'text-danger',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      }).then(result => {
        if (result) {
          this.loading = true
          this.$axios.delete('/documents/' + this.documents[row.index]._id).then(() => {
            this.$bvToast.toast('مستند با موفقیت حذف شد', { variant: 'success', title: 'هورا' })
          }).catch(err => {
            this.$bvToast.toast(err.text, { variant: 'danger', title: 'خطا' })
          }).finally(() => {
            this.loading = false
            this.fetchDocumentsData()
          })
        }
      })
    },
    clickOnPage(bvEvent, page) {
      if (bvEvent) bvEvent.preventDefault()
      this.pagination.page = this.queryParams.page = page
      this.fetchDocumentsData()
    },
    clearSearch() {
      this.searchTerm = ''
      delete this.queryParams.q
      this.nothingToShow = false
      this.fetchDocumentsData()
    },
    onTableSortChanged({ sortBy, sortDesc }) {
      this.queryParams["sort_by"] = sortBy
      this.queryParams["sort_order"] = (sortDesc) ? 'desc' : 'asc'
      this.fetchDocumentsData()
    },
    onSearchByChanged() {
      if (Array.isArray(this.selectSearchBy.selected) && this.selectSearchBy.selected.length > 0) {
        this.queryParams["search_by"] = _.chain(this.selectSearchBy.selected).map('key').join(',').value()
      } else {
        delete this.queryParams["search_by"]
      }
      this.fetchDocumentsData()
    },
    onKeywordFilterChanged() {
      if (Array.isArray(this.selectKeywords.selected) && this.selectKeywords.selected.length > 0) {
        this.queryParams["keyword_ids"] = _.chain(this.selectKeywords.selected).map('_id').join(',').value()
      } else {
        delete this.queryParams["keyword_ids"]
      }
      this.clickOnPage(null, 1)
      this.fetchDocumentsData()
    },
    onReferenceFilterChanged() {
      if (Array.isArray(this.selectReferences.selected) && this.selectReferences.selected.length > 0) {
        this.queryParams["reference_ids"] = _.chain(this.selectReferences.selected).map('_id').join(',').value()
      } else {
        delete this.queryParams["reference_ids"]
      }
      this.clickOnPage(null, 1)
      this.fetchDocumentsData()
    },
    onTopicFilterChanged() {
      if (Array.isArray(this.selectTopics.selected) && this.selectTopics.selected.length > 0) {
        this.queryParams["topic_ids"] = _.chain(this.selectTopics.selected).map('_id').join(',').value()
      } else {
        delete this.queryParams["topic_ids"]
      }
      this.clickOnPage(null, 1)
      this.fetchDocumentsData()

    }
  }
}
</script>

